import {connect} from 'react-redux';
import Review, {ReviewProps} from './Review';
import Action from '../../redux/Actions';
import Constants, {ModalStates} from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import ReviewModel from '../../types/ReviewModel';
import UserModel from '../../types/UserModel';
import ReviewVersionModel from '../../types/ReviewVersionModel';
import {RouteComponentProps, withRouter} from 'react-router';

const mapStateToProps = (state: ReduxState, ownProps: ReviewContainerProps): Partial<ReviewProps> => {
   return {
      review: state.currentReview || {} as ReviewModel,
      reviewVersion: state.currentReviewVersion || {} as ReviewVersionModel,
      player: state.player,
      annotationMode: state.annotationMode,
      currentTime: state.playTime || 0,
      modalState: state.modalState || ModalStates.closed,
      currentUser: state.currentUser || {} as UserModel,
      isCommentHotkeyEnabled: state.isCommentHotkeyEnabled,
      themeName: state.themeName || Constants.themeName.default,
      versionLoading: ownProps.versionLoading,
      hasOwnerPermissions: state.isOwner,
      history: ownProps.history,
      location: ownProps.location,
      match: ownProps.match
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<ReviewProps> => {
   return {
      setSelectedComment: selectedComment => {
         dispatch(Action.setSelectedComment(selectedComment));
      },
      setAnnotationMode: annotationMode => {
         dispatch(Action.setAnnotationMode(annotationMode));
      },
      setModalState: modalState => {
         dispatch(Action.setModalState({modalState}));
      }
   };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Review));

export interface ReviewContainerProps extends RouteComponentProps {
   versionLoading: boolean;
}
